module.exports = __webpack_public_path__ + "fonts/CCDashDecentW00-Heavy.c7e7f8a9.eot";